import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsMapViewedParams = {
  trail_id: number;
};

/**
 * User scrolls to the map section of the trail details page. This will be fired when the map section goes into view not when the section is 100% visible.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsMapViewed = ({ trail_id }: logTrailDetailsMapViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details map viewed', { 'trail id': trail_id }, callback);
};

export default logTrailDetailsMapViewed;
